

import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";

export function HomeModel() {
    const apiModel = ChartstwitsRepository();
    const imagePath = apiModel.chartTwitsImagePath;

    const [lstMostActive, setMostActive] = useState(
        [{
            Post_ID: 0,
            Ticker: "",
            CatalystDate: "",
            SubscriptionGroup_ID: 0,
            Liked: 0,
            Shared: 0,
            ReactionsUpdatedDate: "",
            ImageName: "",
            Message: "",
            Period: "",
            Entry: 0,
            Exit: 0,
            Target: 0,
            Pattern: "",
            Approved: 0,
            Blocked: 0,
            TotalLikesCount: 0,
            TotalCommentsCount: 0,
            TotalLikesandCommentsCount: 0,
            UserName: "",
            User_ID: 0,
            UserImage: "",
            UpdatedDate: "",
            CurrentDate: "",
            CreatedDate: "",
            Follower: 0,
            Type: "",
            UserEmail: "",
            UserDateOfBirth: "",
            badge: "",
            noofgroups: 0,
            nooffollowers: 0,
            nooffollowings: 0
        }]
    )

    const [dates, setDatas] = useState([{
        date: "",
        COUNT: 0
    }])

    const [rewardpoint,setReward ] = useState(0);

    const [dataDate,setDate] = useState({
        startDate : '',
        endDate : '',
    })

    const [rewardStatus,setRewardStatus ] = useState('');

    const [postDetail,setpostDetail] = useState({
        Post_ID: 0,
        Ticker: "",
        CatalystDate: "",
        SubscriptionGroup_ID: 0,
        Liked: 0,
        Shared: 0,
        ReactionsUpdatedDate: "",
        ImageName: "",
        Message: "",
        Period: "",
        Entry: 0,
        Exit: 0,
        Target: 0,
        Pattern: "",
        Approved: 0,
        Blocked: 0,
        TotalLikesCount: 0,
        TotalCommentsCount: 0,
        TotalLikesandCommentsCount: 0,
        UserName: "",
        User_ID: 0,
        UserImage: "",
        UpdatedDate: "",
        CurrentDate: "",
        CreatedDate: "",
        Follower: 0,
        Type: "",
        UserEmail: "",
        UserDateOfBirth: "",
        badge: "",
        noofgroups: 0,
        nooffollowers: 0,
        nooffollowings: 0
    })

    const [comment,setComment] = useState({
        ChartTwit_ID : 0,
        UserId : 0,
        ChartComment : '',
        Type : '',
    })

    const getDates = async () => {
        debugger;
        const responseData: any = await apiModel.getdatesforcatalyst();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setDatas(responseData)
        }
    }

    const getDataBydate = (d:any) =>{
        debugger;
        // let startdata = new Date(d.date);
        
        debugger;

        let currentDate = new Date();
        let startdata = new Date(d.date + ' ' + currentDate.getFullYear());
        let date = convertDate(startdata);
        // const dates = {...dataDate}
        // dates.startDate = date+' '+'00:00:00';
        // dates.endDate = date+' '+'23:59:59';
        // setDate(dates);
        getdata((date+' '+'00:00:00'),(date+' '+'23:59:59'));
    }

    const  convertDate = (inputDate:any) => {
        const date = new Date(inputDate);
        
        // Extract year, month, and day
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
        const day = String(date.getDate()).padStart(2, '0');
        
        // Format the date as YYYY-MM-DD
        const formattedDate = `${year}-${month}-${day}`;
        
        return formattedDate;
    }

    const getdata = async (startDate:any,endDate:any) => {
        debugger;

        let dates = {...dataDate};
        dates.startDate = startDate;
        dates.endDate = endDate;
        setDate(dates);

        var Details = { 'FromDate': startDate, 'ToDate': endDate};
        const responseData: any = await apiModel.gethomedataForChartsandTwits(Details);
        debugger;
        if (responseData.length > 0) {
            debugger;
            setMostActive(responseData)
        }
    }

    const reactionClick = async (d:any,e:any) =>{
        debugger;
        saveChartReactions(d,e);
    }

    const saveChartReactions = async (d:any,e:any) =>{
        debugger;
        const responseData: any = await apiModel.saveChatReactions(d,e);
        getdata(dataDate.startDate,dataDate.endDate)
        debugger;
    }

    const rewardUser = (d:any) =>{
        debugger;
        
        setpostDetail(d);
    }

    const reward = (d:any) =>{
        debugger;
        setReward(d);
    }

    const saveReward = async () =>{
        debugger;
        const responseData: any = await apiModel.savePoints(postDetail,rewardpoint);
        debugger;
        if(responseData[0].dbResult > 0){
            
            const buttonElement = document.getElementById('alertAction') as HTMLButtonElement | null;
            if (buttonElement) {
                buttonElement.click();
            }

            setRewardStatus('Rewarded Successfully.');

        }else if(responseData != null && responseData.length > 0 && responseData[0].dbResult == -3){
            const buttonElement = document.getElementById('alertAction') as HTMLButtonElement | null;
            if (buttonElement) {
                buttonElement.click();
            }
            setRewardStatus('Rewarded Already!');
        }
    }

    const addComment = async (d:any) =>{
        debugger;
        let newPost = {...comment};
        newPost.ChartTwit_ID = d.Post_ID;
        newPost.Type = d.Type;
        setComment(newPost);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        debugger;
        if ('value' in e.target) {
            debugger;
            const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement;
            setComment((prev) => ({ ...prev, [name]: value }));
        }
        else {
            debugger;
            const { name, value } = e.target as HTMLSelectElement;
            setComment((prev) => ({ ...prev, [name]: value }));
        }
    };


    const postComment = async () =>{
        debugger;
        if(comment.ChartComment !='' && comment.Type =='Chart'){
            debugger;
            const responseData: any = await apiModel.saveChartComment(comment);
            debugger;
            alert(1);
        }else if(comment.ChartComment !='' && comment.Type =='Twit'){
            // const responseData: any = await apiModel.saveTwitComment(comment);
        }
    }


    useEffect(() => {
        getDates();
    }, [alert])

    return { dates,getDataBydate,lstMostActive,imagePath,reactionClick,reward, rewardpoint,
        saveReward,rewardUser,rewardStatus,comment,postComment,addComment,handleChange}
}